<template>
  <van-overlay :show="show">
    <div class="share">
      点击右上角
      <img :src="$oss(31)" width="32" height="12" class="margin-lr-4" />
      发送给好友
      <div class="arrow"></div>
    </div>

    <div class="i-kown" @click="onClose">我知道了</div>
  </van-overlay>
</template>

<script>
import Vue from 'vue'
import { Overlay } from 'vant'

Vue.use(Overlay)
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onClose () {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.share {
  position: absolute;
  right: 20px;
  top: 16px;
  color: white;
  display: flex;
  align-items: center;
  font-size: 12px;
  border: 1px solid white;
  padding: 4px 14px;
  border-radius: 20px;
}

.i-kown {
  color: #fff;
  position: absolute;
  transform: translateX(-50%);
  left: 50%;
  bottom: 60px;
  border: 1px solid white;
  padding: 6px 20px;
  border-radius: 20px;
}

.arrow {
  position: absolute;
  right: 54px;
  top: -12px;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 12px solid #fff;
}
</style>
